import React from "react";
import Toast from "../components/ToastContainer/CustomToast";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  console.error("Error caught in ErrorBoundary:", error);
  Toast("Something went wrong in a component.", "error");

  return null; // render nothing, or some minimal UI
};

export default ErrorFallback;
